import { render, staticRenderFns } from "./SugarYield.vue?vue&type=template&id=8317ba24&scoped=true&"
import script from "./SugarYield.vue?vue&type=script&lang=ts&"
export * from "./SugarYield.vue?vue&type=script&lang=ts&"
import style0 from "./SugarYield.vue?vue&type=style&index=0&id=8317ba24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8317ba24",
  null
  
)

export default component.exports